const prefix = 'dataset-table';

export const datasetTableI18n = {
    uuid: {
        id: `${prefix}.uuid`,
        defaultMessage: 'UUID',
    },
    name: {
        id: `${prefix}.name`,
        defaultMessage: 'Name',
    },
    description: {
        id: `${prefix}.description`,
        defaultMessage: 'Description',
    },
    workspace: {
        id: `${prefix}.workspace`,
        defaultMessage: 'Workspace',
    },
    lengthUnits: {
        id: `${prefix}.lengthUnits`,
        defaultMessage: 'Length Units',
    },
    status: {
        id: `${prefix}.status`,
        defaultMessage: 'Status',
    },
    createdAt: {
        id: `${prefix}.createdAt`,
        defaultMessage: 'Created At',
    },
    noDatasetsTitle: {
        id: `${prefix}.noDatasetsTitle`,
        defaultMessage: 'No datasets',
    },
    loadErrorTitle: {
        id: `${prefix}.loadErrorTitle`,
        defaultMessage: 'Could not load datasets',
    },
    loadErrorMessage: {
        id: `${prefix}.loadErrorMessage`,
        defaultMessage: 'Refresh the page to try again.',
    },
} as const;
